import BaseModel from '@/models/base';

export default class Protocol extends BaseModel {
  static entity = 'protocols';
  static apiPath = 'protocols';
  static routeName = 'protocol';

  static fields() {
    return {
      id: this.attr(null),
      title: this.string(''),
      date: this.date(null),
      file_id: this.attr(null),
      publishing_datetime: this.date(new Date().toISOString()),
      is_published: this.boolean(false),
    };
  }

  get file() {
    if (!this.file_id) { return null; }

    return this.constructor.relation('files').find(this.file_id);
  }
}
